module.exports = __webpack_public_path__ + "static/IBMPlexSerif-Bold-5609827eb00a5f85a81b012f220edb82.woff2";